import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesAssistant from 'components/organisms/Assistants/EntitiesAssistant/EntitiesAssistant';

const StyledCollectionEntitiesAssistant = styled(EntitiesAssistant)`
  ${ComponentStyles}
`;

StyledCollectionEntitiesAssistant.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitiesAssistant;
